import { Injectable } from '@angular/core';
import {HttpHeaders, HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json; charset=utf-8; boundary=' + Math.random().toString().substr(2) + ';',
    })
  }

  API_URL = "https://cvalesegtop.com.br/api-cvaletop/public/api/";
  private readonly apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json';
  private readonly apiKey = 'AIzaSyDtm2cRzQx-eUZhNbaKoBQM5MEXooBa3Hw';
  //API_URL = "http://localhost:8000/api/";
  //API_URL = "/api/";

  constructor(private http: HttpClient) { }

  getListagem(acao) {
    return this.http.get(this.API_URL + acao, this.httpOptions);
  }

  getListagemId(acao, id) {
    return this.http.get(this.API_URL + acao + '/' + id, this.httpOptions);
  }

  getListagemIds(acao, id, sen) {
    return this.http.get(this.API_URL + acao + '/' + id + '/' + sen, this.httpOptions);
  }

  autenticarApp(acao, email, senha) {
    return this.http.get(this.API_URL + acao + '/' + email + '/' + senha, this.httpOptions);
  }

  saveCadastro(acao, form) {
    return this.http.post(this.API_URL + acao, form, this.httpOptions);
  }

  upCadastro(acao, form) {
    return this.http.put(this.API_URL + acao, form, this.httpOptions);
  }

  delCadastro(acao, id) {
    return this.http.delete(this.API_URL + acao + '/' + id, this.httpOptions);
  }

  addResposta(acao, item, id) {
    return this.http.post(this.API_URL + acao + '/' + item + '/' + id, this.httpOptions);
  }

  salvarRespostas(acao, l, q, r, v, a, vr, justificativa: string = '') {
    return this.http.put(this.API_URL + acao + '/' + l + '/' + q + '/' + r + '/' + v + '/' + a + '/' + vr + '/' + justificativa, this.httpOptions);
  }

  cancelarRespostas(acao, l, q) {
    return this.http.put(this.API_URL + acao + '/' + l + '/' + q, this.httpOptions);
  }

  getEnviarEmail(acao, email, senha) {
    return this.http.get(this.API_URL + acao + '/' + email + '/' + senha, this.httpOptions);
  }

  public getEstados() {
    console.log('Estados');
    return this.http.get("../assets/json/estados.json", this.httpOptions);
  }

  public getCidades() {
    console.log('Cidades');
    return this.http.get("../assets/json/cidades.json", this.httpOptions);
  }

  saveCadastroId(acao, face, valor, id) {
    return this.http.put(this.API_URL + acao + '/' + face + '/' + valor + '/' + id, this.httpOptions);
  }

  checkout(acao, form) {
    return this.http.post(this.API_URL + acao, form, this.httpOptions);
  }

  getLocalizacao(searchParams) {
    const params = new HttpParams()
      .set('address', encodeURIComponent(searchParams))
      .set('key', this.apiKey);
    return this.http.get(this.apiUrl, { params });

    /*const httpOptions = {
      headers: { 'Content-Type': 'application/json' }
    };
    var api = "https://maps.googleapis.com/maps/api/geocode/json?address="+encodeURIComponent(searchParams)+"&key=AIzaSyDtm2cRzQx-eUZhNbaKoBQM5MEXooBa3Hw";
    var Url = "https://cartoriotop.com.br/anoreg-api-google/api-maps.php?param=" + btoa(api);
    //var Url = "http://localhost:8888/anoreg-api-google/api-maps.php?param=" + btoa(api);
    return this.http.get(Url, this.httpOptions);*/
  }
}
